import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconChevronDoubleLeftSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.207 6.707 12.914 6 11.5 4.586l-.707.707-6 6-.707.707.707.707 6 6 .707.707L12.914 18l-.707-.707L6.914 12l5.293-5.293Zm7 0L19.914 6 18.5 4.586l-.707.707-6 6-.707.707.707.707 6 6 .707.707L19.914 18l-.707-.707L13.914 12l5.293-5.293Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconChevronDoubleLeftSharp);
export default Memo;
